import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";

const PaymentSuccess = () => {
  const [message, setMessage] = useState("Processing your payment...");
  const [failed, setFailed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const status = params.get("razorpay_payment_link_status");
    const referenceId = params.get("razorpay_payment_link_reference_id");

    if (status && status !== "paid") {
      setFailed(true);
      setMessage("Your payment didn't go through. Please try booking again.");
      return;
    }

    // The booking id/code is read from Razorpay's own callback params, not
    // just whatever "currentBookingId" happened to already be in
    // localStorage — that value was written in the original tab before
    // redirecting to Razorpay's hosted page, and isn't guaranteed to
    // survive the round-trip (e.g. a UPI app handoff can land back in a
    // different browser context with no access to it). This is the same
    // { booking_id, booking_code } shape BookingReview.jsx already writes;
    // the backend's booking lookup accepts either a real id or a
    // booking_code in that field and auto-detects which one it got.
    if (referenceId) {
      localStorage.setItem(
        "currentBookingId",
        JSON.stringify({ booking_id: referenceId, booking_code: referenceId })
      );
    }

    setMessage("Payment successful! Redirecting...");
    const timer = setTimeout(() => navigate("/booking-success"), 1200);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        background: "#f8f9fa",
        textAlign: "center",
        padding: "0 20px",
      }}
    >
      {!failed && <ClipLoader size={45} />}

      <p
        style={{
          marginTop: "20px",
          fontSize: "16px",
          color: "#444",
        }}
      >
        {message}
      </p>

      {failed && (
        <a href="/" className="theme-btn" style={{ textDecoration: "none", marginTop: "10px" }}>
          Back to Home
        </a>
      )}
    </div>
  );
};

export default PaymentSuccess;
